__turbopack_context__.v({
  "attribution": "_Kw-pG_attribution",
  "content": "_Kw-pG_content",
  "imageWrapper": "_Kw-pG_imageWrapper",
  "imageWrapperNoImage": "_Kw-pG_imageWrapperNoImage",
  "materials": "_Kw-pG_materials",
  "noImageContainer": "_Kw-pG_noImageContainer",
  "noImageSvg": "_Kw-pG_noImageSvg",
  "statement": "_Kw-pG_statement",
  "statementHeader": "_Kw-pG_statementHeader",
  "text": "_Kw-pG_text",
  "thumbnail": "_Kw-pG_thumbnail",
  "thumbnails": "_Kw-pG_thumbnails",
  "title": "_Kw-pG_title",
});
